import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Installer from 'modules/installer';
import PrintPreview from 'modules/main/lab_result/print_result/raw';
import IdleTimerComponent from 'shared_components/idle_timer';
import PrivateRoute from 'shared_components/private_route';
import MainLayout from './shared_components/layout';
import wsService from "./services/websocket/WebSocketService";
import { createSession, waitForClientId } from "./services/session/session";
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

// CSS
import './App.css';

const history = createBrowserHistory({ basename: process.env.PUBLIC_URL });

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
		messages: [],
		};
	}

	async componentDidMount() {
		wsService.connect(process.env.REACT_APP_WEBSOCKET);

		this.unsubscribe = wsService.subscribe((msg) => {
		this.setState((prevState) => ({
			messages: [...prevState.messages, msg],
		}));
		});

		const userData = sessionStorage.getItem(LOGGEDIN_USER_DATA);
		if (userData) {
				await waitForClientId(5000);
				await createSession('INITIALIZED');
		}
	}

	componentWillUnmount() {
		if (this.unsubscribe) {
		this.unsubscribe();
		}
	}
		
	// sendMessage = () => {
	// 	wsService.sendMessage({ user: "App", text: "Hello from App.js!" });
	// };
	
	render() {
		return (
			<div>
				<IdleTimerComponent />
				<Router history={history}>
					<Switch>
						<Route path="/installer" component={Installer} />
						<PrivateRoute
							exact
							path="/lab/result/print/:requestID/:sampleID"
							component={PrintPreview}
						/>
						<Route path="/" component={MainLayout} />
					</Switch>
				</Router>
			</div>
		);
	}
}

export default App;
